angular.module('gc.notifs', [])
  .service('Notifs', [
    '$rootScope', '$http', 'API_URL', 'WS_URL', 'WS', 'CommentService', 'GcUser',
    function($rootScope, $http, API_URL, WS_URL, WS, CommentService, GcUser)
  {
    return {

      notifs: [],

      init: function(wsEnabled) {
        if (GcUser.getUser()) {
          wsEnabled && this.connect('ready');
          this.fetch();
        }

        $rootScope.$on('logged_in', function(event, user) {
          this.notifs = [];
          if (!user._id) return
          wsEnabled && this.connect('reconnect');
          this.fetch();
        }.bind(this));
      },

      onMsg: function(data) {
        // append new notif
        if (data.msg) {
          // sometimes the WS server send messages twice (need to fix the server)
          // in that case, we do nothing
          if (this.notifs.find(n => n._id === data.msg._id)) return;

          this.notifs.unshift(data.msg);
          $rootScope.$broadcast('notif', data.msg);
        }
      },

      onOpen: function (event) {
        // join channel
        var ws = this;
        var user = GcUser.getUser();
        var websiteId = CommentService.website._id;
        if (!user) return;
        ws.send(JSON.stringify({ joinUser: websiteId + user._id }));
      },

      connect: function(from) {
        console.debug('WS connect', from);
        var ws = WS.create(this.onMsg.bind(this), this.onOpen);
      },

      fetch: function() {
        // fetch all previous notifs
        return $http.get(API_URL + '/users/notifications/website/' + CommentService.website._id + '?page_size=300')
          .success(function(resp) {
            if (resp.gcCode) return;
            this.notifs = resp.notifications || [];
          }.bind(this));
      },

      updateViews: function (notifIds) {
        return $http.put(API_URL + '/users/notifications/website/' + CommentService.website._id, {
          ids: notifIds.join(',')
        }).success(function() {
          for (var i = 0; i < notifIds.length; i++) {
            this.notifs.find(n => n._id === notifIds[i]).view = true;
          }
        }.bind(this));
      },

    };
}]);
